<template>
  <div class="main-container">
    <div class="top-card-div">
      <div class="top-cards">
        <user-card :showProfilePic="true" heading="Personal Information" logo="userIcon" :data='data.personal_info'/>
      </div>
       <div class="top-cards_customer">
       <customer-value-card heading="Customer Value" logo="tractor" :data="data.customer_value"/>
      </div>
      <div class="top-cards-engagement">
        <insight-card :showProfilePic="false" heading="Engagement Insights" logo="thumbsup" :data='data.engagement_insights'/>
      </div>
     
    </div>
    <div class="top-card-div">
      <button-card :btnColor="true" logo="briefcase" heading="Business Interests" :data="data.business_interests" id='business_interests' key="business_interests"/>
      <button-card :btnColor="false" logo="heart" heading="Other Interests" :data="data.other_interests" id='other_interests' key="other_interests"/>
      <insurance-card :data="data.insurance_details"/>
    </div>
    <div class="top-card-div">
      <land-card heading="Land" logo="land" :data="data.land_info"/>
      <tractor-card heading="Tractor" logo="tractor" :data="data.tractor_info"/>
      <cattle-card heading="Cattle" logo="cattle" :data="data.cattle_info"/>
    </div>
    <div class="top-card-div">
      <listing-card heading="Crops" type="crops" :data="crops"/>
    </div>
    <div class="top-card-div">
      <brand-listing-card heading="Brands and Products" type="brands" :data="brands"/>
    </div>
   
  </div>
</template>
  
<script>
import userCard from "./user-card.vue";
import buttonCard from "./button-card.vue";
import bottomCard from "./bottom-card.vue";
//import middleCard from "./middle-card.vue";
import listingCard from "./listing-card.vue"
import insightCard from "./insight-card.vue"
import insuranceCard from "./insurance-card.vue"
import landCard from "./land-card.vue"
import tractorCard from "./tractor-card.vue"
import cattleCard from "./cattle-card.vue"
import brandListingCard from "./brand-listing.vue"
import customerCard from './customer-value-card.vue'
export default {
  name: "mainContainer",
  data() {
    return {
      selectedTab: 0,
    };
  },
  components: {
    "user-card"  : userCard,
    "button-card": buttonCard,
    "bottom-card": bottomCard,
   // "middle-card": middleCard,
    "listing-card":listingCard,
    "insight-card":insightCard,
    "insurance-card":insuranceCard,
    "land-card":landCard,
    "cattle-card":cattleCard,
    "tractor-card":tractorCard,
    "brand-listing-card":brandListingCard,
    "customer-value-card":customerCard,

  },
  props:{
    data:{
      default:null
    },
    crops:null,
    brands:null,
  },
  methods: {
  
  },
};
</script>
  <style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 32px;
  margin-top: 48px;
  overflow-y: scroll;
  padding-bottom: 32px;
}
.top-card-div {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 24px;
}

.top-cards {
  height: 280px;
  width: 50%;
  background-color: #ffff;
  border-radius: 8px;
}.top-cards-engagement{
   height: 280px;
  width: 30%;
  background-color: #ffff;
  border-radius: 8px;
}
.top-cards_customer{
  height: 280px;
  width: 30%;
  background-color: #ffff;
  border-radius: 8px;
}
</style>